import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { TkRouteContext } from "../../context/tkRouteContext";
import "./_style.scss";
import {
  httpIAPI_STA008,
  httpIAPI_STA039,
  httpIAPI_STA040,
} from "./api/request";
import {
  explanatoryText,
  fakeTableList,
  schema,
  schemaOneAndThree,
  schemaOnlyThree,
  schemaOnlyTwo,
  schemaRegNum,
  schemaThree,
  schemaTwo,
  schemaTwoAndThree,
  stepper,
} from "./parts";
import { API_STA008_BuildReqParams } from "../../utils/buildRequestParams";
import dayjs from "dayjs";
import _ from "lodash";
import { FormList } from "../../type/apiType/IAPI_STA008";
import {
  AttachmentRegistStatus,
  FormClassRetire,
  FormKbn,
  Status,
} from "../../assets/data/Constants";
import { IAPI_STA039_Response } from "../../type/apiType";
import { IJob_32Props } from "../../type/contextType/businessContext/IJob_32";
import { toNumberOrUndefined } from "../../utils/useTools";

/**
 * SCRC060125 退職情報　登録（添付書類の確認）
 * @return SCRC060125 退職情報　登録（添付書類の確認）
 */
const SCRC060125 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [stateInfoList, setStateInfoList] = useState<any>([]);
  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.job_32;
  // ダイアログ開閉状態（合計）
  const [isOpenSaveDialog, setIsOpenSaveDialog] = useState<boolean>(false);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const [showTwoTable, setShowTwoTable] = useState<boolean>(false);
  const [showThreeTable, setShowThreeTable] = useState<boolean>(false);
  const [fromManger, setFromManager] = useState<boolean>(false);
  const { state: stateRouter } = useContext(TkRouteContext);
  const [latCheck, setLatCheck] = useState<boolean>(false);
  const [latCheckTwo, setLatCheckTwo] = useState<boolean>(false);
  const [latCheckThree, setLatCheckThree] = useState<boolean>(false);
  const [regNumCon, setRegNumCon] = useState<number>();
  const [schemaType, setSchemaType] = useState<string>("1");
  const routerList = stateRouter.routerList || [];
  const sta039DataRef = useRef<any>();

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    switch (regNumCon) {
      case 0:
        setShowTwoTable(false);
        setShowThreeTable(false);
        break;
      case 1:
        setShowTwoTable(false);
        setShowThreeTable(false);
        break;
      case 2:
        setShowTwoTable(true);
        setShowThreeTable(false);
        break;
      case 3:
        setShowTwoTable(true);
        setShowThreeTable(true);
        break;
    }
    // 一枚目
    const _showOneTable = !!regNumCon && !latCheck;

    resArr.find((item) => item.keyword === "regLater")!.showLine = !!regNumCon;

    resArr.find((item) => item.keyword === "dateEmp")!.showLine = _showOneTable;
    resArr.find((item) => item.keyword === "dateRetiree")!.showLine =
      _showOneTable;
    resArr.find((item) => item.keyword === "classIfication")!.showLine =
      _showOneTable;
    resArr.find((item) => item.keyword === "paymentAmt")!.showLine =
      _showOneTable;
    resArr.find((item) => item.keyword === "levyAmount")!.showLine =
      _showOneTable;
    resArr.find((item) => item.keyword === "specialAmount")!.showLine =
      _showOneTable;
    resArr.find((item) => item.keyword === "prefecturesAmount")!.showLine =
      _showOneTable;
    resArr.find((item) => item.keyword === "conYears")!.showLine =
      _showOneTable;
    resArr.find((item) => item.keyword === "sourceBill")!.showLine =
      _showOneTable;
    resArr.find((item) => item.keyword === "deductionYear")!.showLine =
      _showOneTable;
    resArr.find((item) => item.keyword === "deductionMonth")!.showLine =
      _showOneTable;

    // 二枚目
    const _showTwoTable = (regNumCon === 2 || regNumCon === 3) && !latCheckTwo;
    resArr.find((item) => item.keyword === "regLaterTwo")!.showLine =
      regNumCon === 2 || regNumCon === 3;
    resArr.find((item) => item.keyword === "dateEmpTwo")!.showLine =
      _showTwoTable;
    resArr.find((item) => item.keyword === "dateRetireeTwo")!.showLine =
      _showTwoTable;
    resArr.find((item) => item.keyword === "classIficationTwo")!.showLine =
      _showTwoTable;
    resArr.find((item) => item.keyword === "paymentAmtTwo")!.showLine =
      _showTwoTable;
    resArr.find((item) => item.keyword === "levyAmountTwo")!.showLine =
      _showTwoTable;
    resArr.find((item) => item.keyword === "specialAmountTwo")!.showLine =
      _showTwoTable;
    resArr.find((item) => item.keyword === "prefecturesAmountTwo")!.showLine =
      _showTwoTable;
    resArr.find((item) => item.keyword === "conYearTwo")!.showLine =
      _showTwoTable;
    resArr.find((item) => item.keyword === "sourceBillTwo")!.showLine =
      _showTwoTable;
    resArr.find((item) => item.keyword === "deductionYearTwo")!.showLine =
      _showTwoTable;
    resArr.find((item) => item.keyword === "deductionMonthTwo")!.showLine =
      _showTwoTable;
    // 三枚目
    const _showThreeTable = regNumCon === 3 && !latCheckThree;
    resArr.find((item) => item.keyword === "regLaterThree")!.showLine =
      regNumCon === 3;
    resArr.find((item) => item.keyword === "dateEmpThree")!.showLine =
      _showThreeTable;
    resArr.find((item) => item.keyword === "dateRetireeThree")!.showLine =
      _showThreeTable;
    resArr.find((item) => item.keyword === "classIficationThree")!.showLine =
      _showThreeTable;
    resArr.find((item) => item.keyword === "paymentAmtThree")!.showLine =
      _showThreeTable;
    resArr.find((item) => item.keyword === "levyAmountThree")!.showLine =
      _showThreeTable;
    resArr.find((item) => item.keyword === "specialAmountThree")!.showLine =
      _showThreeTable;
    resArr.find((item) => item.keyword === "prefecturesAmountThree")!.showLine =
      _showThreeTable;
    resArr.find((item) => item.keyword === "conYearThree")!.showLine =
      _showThreeTable;
    resArr.find((item) => item.keyword === "sourceBillThree")!.showLine =
      _showThreeTable;
    resArr.find((item) => item.keyword === "deductionYearThree")!.showLine =
      _showThreeTable;
    resArr.find((item) => item.keyword === "deductionMonthThree")!.showLine =
      _showThreeTable;

    setStateInfoList([...resArr]);

    if (regNumCon === 0) {
      setSchemaType("0");
    } else if (regNumCon === 2) {
      if (latCheck && latCheckTwo) {
        setSchemaType("0");
      } else if (latCheck && !latCheckTwo) {
        setSchemaType("4");
      } else if (!latCheck && latCheckTwo) {
        setSchemaType("1");
      } else {
        setSchemaType("2");
      }
    } else if (regNumCon === 3) {
      if (latCheck && latCheckTwo && latCheckThree) {
        setSchemaType("0");
      } else if (latCheck && latCheckTwo && !latCheckThree) {
        setSchemaType("5");
      } else if (latCheck && !latCheckTwo && latCheckThree) {
        setSchemaType("4");
      } else if (!latCheck && latCheckTwo && latCheckThree) {
        setSchemaType("1");
      } else if (latCheck && !latCheckTwo && !latCheckThree) {
        setSchemaType("6");
      } else if (!latCheck && latCheckTwo && !latCheckThree) {
        setSchemaType("7");
      } else if (!latCheck && !latCheckTwo && latCheckThree) {
        setSchemaType("2");
      } else {
        setSchemaType("3");
      }
    } else {
      if (latCheck) {
        setSchemaType("0");
      } else {
        setSchemaType("1");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    showTwoTable,
    showThreeTable,
    regNumCon,
    latCheck,
    latCheckTwo,
    latCheckThree,
  ]);

  // 初期表示
  const handleInit = async () => {
    let data: IJob_32Props | IAPI_STA039_Response = context ?? {};

    const fromManger = ["/SCRC060031", "/SCRD310002"].includes(
      routerList[routerList.length - 1]?.href ?? ""
    );
    setFromManager(fromManger);

    if (fromManger) {
      try {
        const res = await httpIAPI_STA039({
          applyId: location.state?.applyId ?? businessState.job_32?.applyId,
        });

        if (res.resultCd === "I0000") {
          data = res;
          sta039DataRef.current = res;
          setState({ ...state, errorMsgId: "" });
        } else {
          setState({ ...state, errorMsgId: res.resultCd });
          return;
        }
      } catch (error) {
        navigate("/error");
      }
    }

    let resArr = stateFakeTableList.current;

    // 契約者（法人）名
    let contractorName = resArr.find(
      (item) => item.keyword === "contractorName"
    )!;
    contractorName.showLine = isKiko;
    contractorName.contractorNumber =
      businessState.common?.contractorNo +
      ":" +
      businessState.common?.contractorName;
    // 職員番号
    resArr.find((item) => item.keyword === "staffNo")!.text =
      businessState.job_32?.staffNo;
    // 退職者名
    resArr.find((item) => item.keyword === "retireeName")!.text =
      businessState.job_32?.staffNameKanji;
    // 源泉徴収票の登録枚数
    let regNum = fromManger
      ? (data as IAPI_STA039_Response).withholdTaxSlipTotal
      : (data as IJob_32Props).withholdingTaxSlipTotal;
    resArr.find((item) => item.keyword === "regNum")!.setDefaultValue = regNum;
    resArr.find((item) => item.keyword === "regNum")!.onGetValue = setRegNumCon;
    // 後で登録
    resArr.find((item) => item.keyword === "regLater")!.onGetValue = (
      value: any
    ) => setLatCheck(!!value.length);
    // 区分
    resArr.find((item) => item.keyword === "classIfication")!.setDefaultValue =
      data.page1Kbn;
    // 支払金額
    resArr.find((item) => item.keyword === "paymentAmt")!.setDefaultValue =
      data.page1PaymentAmt;
    // 源泉徴収額
    resArr.find((item) => item.keyword === "levyAmount")!.setDefaultValue =
      data.page1WithholdingAmt;
    // 特別徴収税額：市町村民税
    resArr.find((item) => item.keyword === "specialAmount")!.setDefaultValue =
      data.page1ScAmtCity;
    // 特別徴収税額：都道府県税
    resArr.find(
      (item) => item.keyword === "prefecturesAmount"
    )!.setDefaultValue = data.page1ScAmtPrefecture;
    // 勤続年数
    resArr.find((item) => item.keyword === "conYears")!.setDefaultValue =
      data.page1LengthOfService;
    // 就労年月日
    resArr.find((item) => item.keyword === "dateEmp")!.setDefaultValue =
      data.page1EmployedDate;
    // 退職年月日
    resArr.find((item) => item.keyword === "dateRetiree")!.setDefaultValue =
      data.page1RetiredDate;
    // 控除期間（年）
    resArr.find((item) => item.keyword === "deductionYear")!.setDefaultValue =
      data.page1DeductionPeriodYear;
    // 控除期間（月）
    resArr.find((item) => item.keyword === "deductionMonth")!.setDefaultValue =
      data.page1DeductionPeriodMonth;

    // 2枚目の情報

    // 後で登録二枚目
    resArr.find((item) => item.keyword === "regLaterTwo")!.onGetValue = (
      value: any
    ) => setLatCheckTwo(!!value.length);
    // 就労年月日
    resArr.find((item) => item.keyword === "dateEmpTwo")!.setDefaultValue =
      data.page2EmployedDate;

    // 退職年月日
    resArr.find((item) => item.keyword === "dateRetireeTwo")!.setDefaultValue =
      data.page2RetiredDate;
    // 区分
    resArr.find(
      (item) => item.keyword === "classIficationTwo"
    )!.setDefaultValue = data.page2Kbn;
    // 支払金額
    resArr.find((item) => item.keyword === "paymentAmtTwo")!.setDefaultValue =
      data.page2PaymentAmt;
    // 源泉徴収額
    resArr.find((item) => item.keyword === "levyAmountTwo")!.setDefaultValue =
      data.page2WithholdingAmt;
    // 特別徴収税額：市町村民税
    resArr.find(
      (item) => item.keyword === "specialAmountTwo"
    )!.setDefaultValue = data.page2ScAmtCity;
    // 特別徴収税額：都道府県税
    resArr.find(
      (item) => item.keyword === "prefecturesAmountTwo"
    )!.setDefaultValue = data.page2ScAmtPrefecture;
    // 勤続年数
    resArr.find((item) => item.keyword === "conYearTwo")!.setDefaultValue =
      data.page2LengthOfService;
    // 控除期間（年）
    resArr.find(
      (item) => item.keyword === "deductionYearTwo"
    )!.setDefaultValue = data.page2DeductionPeriodYear;
    // 控除期間（月）
    resArr.find(
      (item) => item.keyword === "deductionMonthTwo"
    )!.setDefaultValue = data.page2DeductionPeriodMonth;

    // 3枚目の情報

    // 後で登録三枚目
    resArr.find((item) => item.keyword === "regLaterThree")!.onGetValue = (
      value: any
    ) => setLatCheckThree(!!value.length);
    // 就労年月日
    resArr.find((item) => item.keyword === "dateEmpThree")!.setDefaultValue =
      data.page3EmployedDate;
    // 退職年月日
    resArr.find(
      (item) => item.keyword === "dateRetireeThree"
    )!.setDefaultValue = data.page3RetiredDate;
    // 区分
    resArr.find(
      (item) => item.keyword === "classIficationThree"
    )!.setDefaultValue = data.page3Kbn;
    // 支払金額
    resArr.find((item) => item.keyword === "paymentAmtThree")!.setDefaultValue =
      data.page3PaymentAmt;
    // 源泉徴収額
    resArr.find((item) => item.keyword === "levyAmountThree")!.setDefaultValue =
      data.page3WithholdingAmt;
    // 特別徴収税額：市町村民税
    resArr.find(
      (item) => item.keyword === "specialAmountThree"
    )!.setDefaultValue = data.page3ScAmtCity;
    // 特別徴収税額：都道府県税
    resArr.find(
      (item) => item.keyword === "prefecturesAmountThree"
    )!.setDefaultValue = data.page3ScAmtPrefecture;
    // 勤続年数
    resArr.find((item) => item.keyword === "conYearThree")!.setDefaultValue =
      data.page3LengthOfService;
    // 控除期間（年）
    resArr.find(
      (item) => item.keyword === "deductionYearThree"
    )!.setDefaultValue = data.page3DeductionPeriodYear;
    // 控除期間（月）
    resArr.find(
      (item) => item.keyword === "deductionMonthThree"
    )!.setDefaultValue = data.page3DeductionPeriodMonth;
    // 退職所得の源泉徴収票
    data.formList?.forEach((item: any) => {
      if (item.formKbn === "6" && item.formClass === "7") {
        if (item.attachDocRegStatus === "9" || item.formStatus === "9") {
          resArr.find((item) => item.keyword === "regLater")!.setDefaultValue =
            ["0"];
          setLatCheck(true);
          return;
        }
        resArr.find((item) => item.keyword === "sourceBill")!.setDefaultValue =
          [
            {
              formName: item.formName ?? item.fileName,
              fileBase64: item.fileBase64,
            },
          ];
      }
      if (item.formKbn === "6" && item.formClass === "39") {
        if (item.attachDocRegStatus === "9" || item.formStatus === "9") {
          resArr.find(
            (item) => item.keyword === "regLaterTwo"
          )!.setDefaultValue = ["0"];
          setLatCheckTwo(true);
          return;
        }
        resArr.find(
          (item) => item.keyword === "sourceBillTwo"
        )!.setDefaultValue = [
          {
            formName: item.formName ?? item.fileName,
            fileBase64: item.fileBase64,
          },
        ];
      }
      if (item.formKbn === "6" && item.formClass === "40") {
        if (item.attachDocRegStatus === "9" || item.formStatus === "9") {
          resArr.find(
            (item) => item.keyword === "regLaterThree"
          )!.setDefaultValue = ["0"];
          setLatCheckThree(true);
          return;
        }
        resArr.find(
          (item) => item.keyword === "sourceBillThree"
        )!.setDefaultValue = [
          {
            formName: item.formName ?? item.fileName,
            fileBase64: item.fileBase64,
          },
        ];
      }
    });

    setRegNumCon(regNum);
    setStateInfoList([...resArr]);
  };

  // 業務チェック
  const businessCheck = (data: any): boolean => {
    let errorMsg = "";
    if (context) {
      if (regNumCon === 3) {
        if (
          !latCheckThree &&
          (dayjs(data.dateRetireeThree) <
            dayjs(
              context.firstJoinDate ?? sta039DataRef?.current?.firstJoinDate
            ) ||
            dayjs(data.dateEmpThree) >
              dayjs(context.retireDate ?? sta039DataRef?.current?.retireDate))
        ) {
          errorMsg = "TKMSG_SCR0035E";
        } else if (!latCheckThree && Number(data.paymentAmtThree) > 30000000) {
          errorMsg = "TKMSG_SCR0011W";
        }
      }
      if (regNumCon === 2 || regNumCon === 3) {
        if (
          !latCheckTwo &&
          (dayjs(data.dateRetireeTwo) <
            dayjs(
              context.firstJoinDate ?? sta039DataRef?.current?.firstJoinDate
            ) ||
            dayjs(data.dateEmpTwo) >
              dayjs(context.retireDate ?? sta039DataRef?.current?.retireDate))
        ) {
          errorMsg = "TKMSG_SCR0035E";
        } else if (!latCheckTwo && Number(data.paymentAmtTwo) > 30000000) {
          errorMsg = "TKMSG_SCR0011W";
        }
      }
      if (
        !latCheck &&
        (dayjs(data.dateRetiree) <
          dayjs(
            context.firstJoinDate ?? sta039DataRef?.current?.firstJoinDate
          ) ||
          dayjs(data.dateEmp) >
            dayjs(context.retireDate ?? sta039DataRef?.current?.retireDate))
      ) {
        errorMsg = "TKMSG_SCR0035E";
      } else if (!latCheck && Number(data.paymentAmt) > 30000000) {
        errorMsg = "TKMSG_SCR0011W";
      }
    }

    setState({ ...state, errorMsgId: errorMsg });

    if (errorMsg) {
      return true;
    }

    return false;
  };

  const makeFormList = (data: any, context?: boolean): FormList[] => {
    let formList =
      businessState.job_32?.formList?.filter(
        (item) =>
          !(
            item.formKbn === FormKbn["退職書類"] &&
            (item.formClass ===
              FormClassRetire["退職所得の源泉徴収票_退職届1枚目"] ||
              item.formClass ===
                FormClassRetire["退職所得の源泉徴収票_退職届2枚目"] ||
              item.formClass ===
                FormClassRetire["退職所得の源泉徴収票_退職届3枚目"])
          )
      ) ?? [];

    let fileName = context ? "formName" : "fileName";
    let formStatus = context ? "attachDocRegStatus" : "formStatus";

    let common = (check: boolean) => {
      return {
        formKbn: FormKbn["退職書類"],
        facilityNo: businessState.job_32?.facilityNo,
        staffNo: businessState.job_32?.staffNo,
        [formStatus]: check
          ? AttachmentRegistStatus["後で登録"]
          : AttachmentRegistStatus["登録済"],
      };
    };

    if (regNumCon) {
      let sourceBill = {
        ...common(latCheck),
        formClass: FormClassRetire["退職所得の源泉徴収票_退職届1枚目"],
        ...(!latCheck && {
          [fileName]: data.sourceBill?.[0]?.formName,
          fileBase64: data.sourceBill?.[0]?.fileBase64,
        }),
      };
      formList.push(sourceBill);
    }
    if (regNumCon === 2 || regNumCon === 3) {
      let sourceBillTwo = {
        ...common(latCheckTwo),
        formClass: FormClassRetire["退職所得の源泉徴収票_退職届2枚目"],
        ...(!latCheckTwo && {
          [fileName]: data.sourceBillTwo?.[0]?.formName,
          fileBase64: data.sourceBillTwo?.[0]?.fileBase64,
        }),
      };
      formList.push(sourceBillTwo);
    }
    if (regNumCon === 3) {
      let sourceBillThree = {
        ...common(latCheckThree),
        formClass: FormClassRetire["退職所得の源泉徴収票_退職届3枚目"],
        ...(!latCheckThree && {
          [fileName]: data.sourceBillThree?.[0]?.formName,
          fileBase64: data.sourceBillThree?.[0]?.fileBase64,
        }),
      };
      formList.push(sourceBillThree);
    }

    formList.forEach((item, index) => (item.serialNo = index + 1));

    return formList;
  };

  // 次へ
  const handleSubmit = async (data: any, index: any) => {
    const dataContext = { ...context };
    Object.keys(dataContext).forEach((item) => {
      if (
        item.startsWith("page1") ||
        item.startsWith("page2") ||
        item.startsWith("page3")
      ) {
        delete dataContext[item as keyof IJob_32Props];
      }
    });
    const dataObj: IJob_32Props = {
      ...(data.regNum !== 0 &&
        !data.regLater?.length && {
          page1Kbn: data.classIfication, // 特別徴収票の区分
          page1PaymentAmt: data.paymentAmt, // 支払金額
          page1WithholdingAmt: data.levyAmount, // 源泉徴収額
          page1ScAmtCity: data.specialAmount, // 特別徴収税額（市町村民税）
          page1ScAmtPrefecture: data.prefecturesAmount, // 特別徴収税額（道府県民税）
          page1LengthOfService: data.conYears, // 勤続年数
          page1EmployedDate: data.dateEmp, // 就職年月日
          page1RetiredDate: data.dateRetiree, // 退職年月日
          page1DeductionPeriodYear: toNumberOrUndefined(data.deductionYear), // 控除期間（年）
          page1DeductionPeriodMonth: toNumberOrUndefined(data.deductionMonth), // 控除期間（月）
        }),
      ...((data.regNum === 2 || data.regNum === 3) &&
        !data.regLaterTwo?.length && {
          page2Kbn: data.classIficationTwo, // 特別徴収票の区分
          page2PaymentAmt: data.paymentAmtTwo, // 支払金額
          page2WithholdingAmt: data.levyAmountTwo, // 源泉徴収額
          page2ScAmtCity: data.specialAmountTwo, // 特別徴収税額（市町村民税）
          page2ScAmtPrefecture: data.prefecturesAmountTwo, // 特別徴収税額（道府県民税）
          page2LengthOfService: data.conYearTwo, // 勤続年数
          page2EmployedDate: data.dateEmpTwo, // 就職年月日
          page2RetiredDate: data.dateRetireeTwo, // 退職年月日
          page2DeductionPeriodYear: toNumberOrUndefined(data.deductionYearTwo), // 控除期間（年）
          page2DeductionPeriodMonth: toNumberOrUndefined(
            data.deductionMonthTwo
          ), // 控除期間（月）
        }),
      ...(data.regNum === 3 &&
        !data.regLaterThree?.length && {
          page3Kbn: data.classIficationThree, // 特別徴収票の区分
          page3PaymentAmt: data.paymentAmtThree, // 支払金額
          page3WithholdingAmt: data.levyAmountThree, // 源泉徴収額
          page3ScAmtCity: data.specialAmountThree, // 特別徴収税額（市町村民税）
          page3ScAmtPrefecture: data.prefecturesAmountThree, // 特別徴収税額（道府県民税）
          page3LengthOfService: data.conYearThree, // 勤続年数
          page3EmployedDate: data.dateEmpThree, // 就職年月日
          page3RetiredDate: data.dateRetireeThree, // 退職年月日
          page3DeductionPeriodYear: toNumberOrUndefined(
            data.deductionYearThree
          ), // 控除期間（年）
          page3DeductionPeriodMonth: toNumberOrUndefined(
            data.deductionMonthThree
          ), // 控除期間（月）
        }),
    };

    if (index === 0) {
      try {
        const param = API_STA008_BuildReqParams({
          ...dataContext,
          ...dataObj,
          formProspectNum: data.regNum,
          businessType: businessState.common?.businessType,
          changedName: context?.staffNameKanji,
          changedNameKana: context?.staffNameKana,
          contractorNo: isKiko
            ? businessState.common?.contractorNo
            : state.authInfo?.contractorNo, //共済契約者番号
          tempSaveStep: 6, // 一時保存ステップ
          formList: makeFormList(data), // 帳票情報リスト
          screenId: "SCRC060125", // 画面ID
        });

        const res = await httpIAPI_STA008(param);

        if (res.resultCd === "I0000") {
          setState({ ...state, errorMsgId: "" });
          setIsOpenSaveDialog(true);
          setBusinessState({
            ...businessState,
            job_32: {
              ...dataContext,
              ...dataObj,
              applyId: res.applyId,
              tempSaveStep: 6,
              updateDateTime: res.updateDateTime,
              withholdingTaxSlipTotal: data.regNum,
              formList: makeFormList(data, true),
            },
          });
        } else {
          setState({ ...state, errorMsgId: res.resultCd });
        }
      } catch (error) {
        navigate("/error");
      }
    } else if (index === 1) {
      if (regNumCon && businessCheck(data)) {
        return;
      }
      setBusinessState({
        ...businessState,
        job_32: {
          ...dataContext,
          ...dataObj,
          withholdingTaxSlipTotal: data.regNum,
          formList: makeFormList(data, true),
        },
      });

      navigate("/SCRC060026");
    } else {
      if (regNumCon && businessCheck(data)) {
        return;
      }

      try {
        const res = await httpIAPI_STA040({
          applyId: location.state?.applyId ?? businessState.job_32?.applyId, //申請id
          formProspectNum: data.regNum, // 源泉徴収票の登録枚数
          ...dataObj,
          formList: makeFormList(data), //帳票情報リスト
          screenId: "SCRC060125", // 画面ID
          latestApplyStatus: Status["添付待ち"],
        });

        if (res.resultCd === "I0000") {
          navigate("/SCRC060031");
          setState({ ...state, errorMsgId: "" });
        } else {
          setState({ ...state, errorMsgId: res.resultCd });
        }
      } catch (error) {
        navigate("/error");
      }
    }
  };

  return (
    <Box data-testid="SCRC060125PageForTest" className="SCRC060125">
      {!fromManger && (
        <>
          <TkStepper
            steps={stepper}
            activeStep={5}
            savaStep={businessState.job_32?.tempSaveStep}
          />
          {explanatoryText}
        </>
      )}

      <TkFakeTable
        list={stateInfoList}
        ruleSchema={
          schemaType === "1"
            ? schema
            : schemaType === "2"
            ? schemaTwo
            : schemaType === "3"
            ? schemaThree
            : schemaType === "4"
            ? schemaOnlyTwo
            : schemaType === "5"
            ? schemaOnlyThree
            : schemaType === "6"
            ? schemaTwoAndThree
            : schemaType === "7"
            ? schemaOneAndThree
            : schemaRegNum
        }
        showButton={false}
        buttonGroup={<TkBackButton />}
        submitButtonGroup={[
          {
            submitButtonText: "一時保存",
            showButton: !fromManger,
          },
          {
            submitButtonText: "次へ",
            showButton: !fromManger,
          },
          {
            submitButtonText: "登録",
            showButton: fromManger,
          },
        ]}
        onCheckAndSubmit={handleSubmit}
      />

      <TkMessageDialog
        open={isOpenSaveDialog}
        onOky={() => setIsOpenSaveDialog(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRC060125;
